import React from "react";
import { PageList } from "../components/pageList";
import { useTableSchema } from "../hooks/useTableSchema";

const Notification = ({ title = "Notification" }) => {
  const [getTableSchema] = useTableSchema();

  return (
    <PageList
      title={title}
      apiEntity={"activityLog"}
      tableSchema={getTableSchema("activityLog")}
      hideActionButton={false}
      readOnly={true}
      showAddButton={false}
    />
  );
};

export default Notification;
